import {
  SanityKeyTermItem,
  SanityKeyTermsBlock,
} from '../../types/generated/graphql-types'
import { KeyTermsBlockProps } from '../components/blocks/KeyTermsBlock'
import { notEmpty } from '../utilities/filters'

export const sanityKeyTermsBlockToKeyTermsProps = ({
  title,
  text,
  terms,
}: SanityKeyTermsBlock): KeyTermsBlockProps => ({
  title: title ?? '',
  text: text ?? '',
  terms:
    terms?.filter(notEmpty).map((item: SanityKeyTermItem) => ({
      title: item.title ?? '',
      text: item.text ?? '',
    })) ?? [],
})
